"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/PhoneInput.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _phone = require('shared/services/phone');
var _phoneMask = require('shared/services/phoneMask');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _TextInput = require('./TextInput'); var _TextInput2 = _interopRequireDefault(_TextInput);
















// A number the server masked for this user can't be parsed or edited: show it
// as read-only text and keep the form value unchanged.
const MaskedPhoneInput = ({
  value,
  className,
  inputClassName,
  nationalInputLabel = 'Phone number',
}) => (
  _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'blm-phone-input', 'blm-phone-input--masked', className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
    , _react2.default.createElement(_TextInput2.default, {
      'aria-label': nationalInputLabel,
      className: _classBuilder2.default.call(void 0, 'blm-phone-input--number', inputClassName),
      isDisabled: true,
      readOnly: true,
      type: "text",
      value: value, __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
    )
  )
)

const EditablePhoneInput = ({
  value = '',
  onChange,
  onBlur,
  hasError,
  isDisabled,
  autoFocus,
  className,
  inputClassName,
  selectClassName,
  nationalInputLabel = 'Phone number',
  phonePolicy = 'strict',
}) => {
  const {
    applyPhonePaste,
    clampNationalPhoneDigits,
    formatNationalPhoneDigits,
    getPhoneCallingCodeOptionOrDefault,
    parsePhoneInputValue,
    toCanonicalPhoneValue,
  } = _phone.getPhoneHelpers.call(void 0, phonePolicy)
  const rootRef = _react.useRef(null)
  const parsedValue = parsePhoneInputValue(value)
  const [callingCode, setCallingCode] = _react.useState.call(void 0, parsedValue.callingCode)
  const [isCallingCodeMenuOpen, setIsCallingCodeMenuOpen] = _react.useState.call(void 0, false)
  _react.useEffect.call(void 0, () => {
    if (value) setCallingCode(parsedValue.callingCode)
  }, [value, parsedValue.callingCode])
  const nationalValue = formatNationalPhoneDigits(callingCode, parsedValue.nationalDigits)
  const selectedOption = getPhoneCallingCodeOptionOrDefault(callingCode)

  const setPhoneValue = (callingCode, nationalDigits) =>
    onChange(toCanonicalPhoneValue(callingCode, nationalDigits))

  const selectCallingCode = (nextCallingCode) => {
    setCallingCode(nextCallingCode)
    setIsCallingCodeMenuOpen(false)
    setPhoneValue(nextCallingCode, clampNationalPhoneDigits(nextCallingCode, parsedValue.nationalDigits))
  }

  const onNationalChange = (event) =>
    setPhoneValue(callingCode, event.target.value)

  const onNationalPaste = (event) => {
    const pastedValue = event.clipboardData.getData('text')
    if (!pastedValue.trim().startsWith('+')) return

    event.preventDefault()
    const nextValue = applyPhonePaste(value, pastedValue)
    setCallingCode(nextValue.callingCode)
    setPhoneValue(nextValue.callingCode, nextValue.nationalDigits)
  }

  const onCompoundBlur = (event) => {
    const nextFocusedElement = event.relatedTarget 
    if (!nextFocusedElement || !_optionalChain([rootRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.contains, 'call', _3 => _3(nextFocusedElement)])) {
      setIsCallingCodeMenuOpen(false)
      _optionalChain([onBlur, 'optionalCall', _4 => _4()])
    }
  }

  return (
    _react2.default.createElement('div', {
      ref: rootRef,
      className: _classBuilder2.default.call(void 0, 'blm-phone-input', hasError && 'blm-phone-input--has-error', className),
      onBlur: onCompoundBlur, __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}

      , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'blm-phone-input--calling-code', selectClassName), __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}
        , _react2.default.createElement('button', {
          'aria-expanded': isCallingCodeMenuOpen,
          'aria-haspopup': "listbox",
          'aria-label': "Country code" ,
          className: "blm-phone-input--calling-code-trigger",
          disabled: isDisabled,
          tabIndex: -1,
          type: "button",
          onClick: () => setIsCallingCodeMenuOpen(isOpen => !isOpen), __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}

          ,  selectedOption.compactLabel 
        )
        ,  isCallingCodeMenuOpen && (
          _react2.default.createElement('div', {
            'aria-label': "Country code options"  ,
            className: "blm-phone-input--calling-code-menu",
            role: "listbox", __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}

            ,  _phone.getPhoneCallingCodeOptions.call(void 0, phonePolicy).map(option => (
              _react2.default.createElement('button', {
                key: option.callingCode,
                'aria-selected': option.callingCode === selectedOption.callingCode,
                className: "blm-phone-input--calling-code-option",
                role: "option",
                type: "button",
                onClick: () => selectCallingCode(option.callingCode), __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}

                ,  option.menuLabel 
              )
            ))
          )
        )
      )
      , _react2.default.createElement(_TextInput2.default, {
        'aria-label': nationalInputLabel,
        autoFocus: autoFocus,
        className: _classBuilder2.default.call(void 0, 'blm-phone-input--number', inputClassName),
        hasError: hasError,
        inputMode: "tel",
        isDisabled: isDisabled,
        placeholder: selectedOption.placeholder,
        type: "tel",
        value: nationalValue,
        onChange: onNationalChange,
        onPaste: onNationalPaste, __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
      )
    )
  )
}

const PhoneInput = props => _phoneMask.isMaskedPhone.call(void 0, props.value)
  ? _react2.default.createElement(MaskedPhoneInput, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}} )
  : _react2.default.createElement(EditablePhoneInput, { ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}} )

exports. default = PhoneInput
